/**
 * Has Any Responsive Values Utility
 *
 * Utility function for checking if any values are set for any breakpoint
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import type { ResponsiveAttributes, ResponsiveBreakpoint } from '../../types';

/**
 * Check if any values are set for any breakpoint
 */
export const hasAnyResponsiveValues = < T >(
	attributes: ResponsiveAttributes< T >,
	checker: ( values: T ) => boolean,
): boolean => {
	return [ 'desktop', 'tablet', 'mobile' ].some( ( breakpoint ) => {
		const values = attributes[ breakpoint as ResponsiveBreakpoint ];
		return values && checker( values );
	} );
};
